export default __webpack_public_path__ + "static/present-perfect-d24f334c8ac32e8f2465d04f9ffc689d.svg";